/**
 * Copyright (c) HashiCorp, Inc.
 */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { timeout, task } from 'ember-concurrency';
import { HdsIcon } from '@hashicorp/design-system-components/components';
// @ts-expect-error: no types
import CopyButton from 'ember-cli-clipboard/components/copy-button';

import './copy-block.scss';

export interface CutCopyBlockSignature {
  Args: {
    clipboardText?: string;
    timeout?: number;
    onSuccess?: () => void;
  };
  Blocks: {
    default: [];
  };

  Element: HTMLDivElement;
}

export default class CutCopyBlock extends Component<CutCopyBlockSignature> {
  @tracked isSuccessfullyCopied = false;

  get timeout() {
    return this.args.timeout || 1000;
  }

  copied = task({ drop: true }, async () => {
    this.isSuccessfullyCopied = true;

    this.args?.onSuccess?.();

    await timeout(this.timeout);
    this.isSuccessfullyCopied = false;
  });

  <template>
    <div class="cut-copy-block" ...attributes>
      <div data-test-copy-block-content>{{yield}}</div>
      <div class="cut-copy-block__copy-button">
        <CopyButton
          @text={{@clipboardText}}
          @onSuccess={{this.copied.perform}}
          class={{if
            this.isSuccessfullyCopied
            "cut-copy-block__copy-button--checked"
            ""
          }}
        >
          <HdsIcon
            @name={{if
              this.isSuccessfullyCopied
              "clipboard-checked"
              "clipboard-copy"
            }}
            @size="16"
          />
        </CopyButton>
      </div>
    </div>
  </template>
}
